import type { TFunction } from 'i18next';
import { ApiError } from '@/api/errors';

/**
 * Map any unknown thrown value to a localized message. Single chokepoint
 * keeps the wording consistent across forms.
 */
export function describeError(t: TFunction, error: unknown): string {
  if (error instanceof ApiError) {
    const key = `errors:${error.code}`;
    const translated = t(key, { defaultValue: '' });
    if (translated && translated !== key) return translated;
    return error.message || t('errors:generic');
  }
  if (error instanceof Error) return error.message || t('errors:generic');
  return t('errors:generic');
}
